import { z } from "zod";
export const dmaUserSchema = z.object({
    name: z.nullable(z.string()),
    userName: z.nullable(z.string()),
    objectId: z.nullable(z.string()),
    isAdmin: z.boolean(),
    id: z.number(),
});
